import Vue from 'vue';

/** Event bus for sending XOMEs events. */
const VulnerabilityEventBus = new Vue();

export default VulnerabilityEventBus;
